"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var clearingNumbers_1 = require("./clearingNumbers");
function bankName(clNumber) {
    if (clNumber === undefined ||
        (typeof clNumber === 'string' && clNumber.length === 0)) {
        throw new Error('A string or number is required');
    }
    var numberString = clNumber.toString();
    var found = clearingNumbers_1.default.find(function (_a) {
        var ranges = _a.ranges;
        return !!ranges.find(function (_a) {
            var min = _a.min, max = _a.max;
            var minString = min.toString();
            var maxString = max.toString();
            return (minString === numberString ||
                maxString === numberString ||
                (clNumber > min && clNumber < max));
        });
    });
    return found ? found.bank : '';
}
exports.bankName = bankName;
function clearingNumbers(name) {
    var foundBank = clearingNumbers_1.default.find(function (_a) {
        var bank = _a.bank;
        return bank === name;
    });
    return foundBank ? foundBank.ranges : [];
}
exports.clearingNumbers = clearingNumbers;
function allBanks() {
    return clearingNumbers_1.default.map(function (bank) { return bank.bank; });
}
exports.allBanks = allBanks;
exports.default = {
    allBanks: allBanks,
    bankName: bankName,
    clearingNumbers: clearingNumbers,
};
